module.exports = "<label for=\"variantRadio${id}\" class=\"{{if soldOut}}not_available{{else}}available{{/if}}\" title=\"${color}\">\n\t<input type=\"radio\"\n\t       id=\"variantRadio${id}\"\n\t       variantId=\"${id}\"\n\t       value=\"${color}\"\n\t       name=\"variant\"\n\t       class=\"labeledInput\"\n\t       image=\"${image}\"\n\t       full_image=\"${fullImage}\"\n\t       artnum=\"${artnum}\"\n\t\t   soldout=\"${soldOut}\"\n\t       {{if soldOut}}disabled1=\"disabled\"{{/if}}/>\n\t<span>${color}</span>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/packages/create_order/templates/variant-item.html
// module id = 59Ni
// module chunks = 2 3 4 5 6 11